// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'degular', 'degular Fallback'","fontWeight":800,"fontStyle":"normal"},"className":"__className_47f28c","variable":"__variable_47f28c"};